import { FC } from 'react'
import s from './Selection.module.sass'
import { Template } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import TypeAndPrice from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice/TypeAndPrice'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Text } from '@shared/ui/Typography/Text'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'

const Selection: FC<
  TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = (props) => {
  const price = props.data.price

  return (
    <BlockBoundary>
      <Template {...props}>
        {!!props.data.discounts.restoplace && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.restoplace}₽
          </PromoBadgeLabel>
        )}

        {!!props.data.discounts.remarked && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.remarked}₽
          </PromoBadgeLabel>
        )}

        {/*<TastyClub tastyClub={props.data.discounts.tastyclub} />*/}

        <TypeAndPrice restType={props.data.type} priceRange={price.level} priceLink={price.tag.url} />

        <Text sizes={'S'}>{props.data.description.title}</Text>
      </Template>
    </BlockBoundary>
  )
}

export default Selection
